module.exports = __webpack_public_path__ + "img/loading.74ab3a4b.svg";